import { useQuery } from '@apollo/client';
import { UserContext } from '@providers/userContextProvider';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { FETCH_CUSTODIAN_CONNECTION_NAMES } from './custodianConnectionBreadcrumb.query';

export const CustodianConnectionBreadcrumb = () => {
  const { custodianConnectionId } = useParams();
  const { activeOrganization } = useContext(UserContext);
  const { data } = useQuery(FETCH_CUSTODIAN_CONNECTION_NAMES, {
    variables: {
      input: {
        filter: { organizationId: activeOrganization?.id },
        pagination: { perPage: 100 },
      },
    },
    skip: !custodianConnectionId || !activeOrganization?.id,
  });
  const connection =
    data?.fetchCustodianConnections?.custodianConnections?.find(
      (item) => item.id === custodianConnectionId,
    );

  return connection?.name ?? '';
};
